import React from 'react';

import {
  CheckBoxOutlineBlank as BaseCheckBoxOutlineBlankIcon,
  CheckBox as BaseCheckBoxIcon,
  Check as BaseCheckIcon
} from '@mui/icons-material';
import {
  Box,
  Checkbox,
  ListItem,
  ListItemText,
  styled
} from '@mui/material';



const MainBox = styled(Box)<{indentLevel: number}>(({ indentLevel, theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  marginLeft: theme.spacing(indentLevel * 4)
}));

const CheckBoxOutlineBlankIcon = styled(BaseCheckBoxOutlineBlankIcon)({
  color: '#87ACB9'
});

const CheckBoxIcon = styled(BaseCheckBoxIcon)({
  color: '#87ACB9'
});

const CheckIcon = styled(BaseCheckIcon)({
  color: '#87ACB9'
});

const FullWidthListItem = styled(ListItem)({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between'
});



interface IProps extends React.HTMLAttributes<HTMLLIElement> {
  text: string;
  selected: boolean;
  indentLevel?: number;

  variant: 'checkbox' | 'checkmark';
  overrideOnChange?: (checked: boolean) => void;
}

export const FC: React.FC<IProps> = props => {
  const defaultProps = (({
    text,
    selected,
    indentLevel,
    variant,
    overrideOnChange,
    ...remainder
  }) => (remainder))(props);

  return (
    <FullWidthListItem {...defaultProps} onClick={
      props.overrideOnChange
        ? () => props.overrideOnChange?.(!props.selected)
        : props.onClick
    }>
      <MainBox indentLevel={props.indentLevel ?? 0}>
        <ListItemText>{props.text}</ListItemText>
      </MainBox>

      {props.variant === 'checkbox' ? (
        <Checkbox
          icon={<CheckBoxOutlineBlankIcon />}
          checkedIcon={<CheckBoxIcon />}
          checked={props.selected} />
      ) : (
        props.selected && (
          <CheckIcon />
        )
      )}

    </FullWidthListItem>
  );
};
